(function () {
    const getSlidesPerView = (width, productCount, productCountMobile) => {
        if (productCount === 6) {
            return width < 576 ? productCountMobile :
                width < 750 ? 2 :
                width < 1100 ? 3 :
                width < 1360 ? 4 :
                width < 1600 ? 5 : 6;
        } else if (productCount === 5) {
            return width < 576 ? productCountMobile :
                width < 750 ? 2 :
                width < 1100 ? 3 :
                width < 1360 ? 4 : 5;
        } else if (productCount === 4) {
            return width < 576 ? productCountMobile :
                width < 750 ? 2 :
                width < 1100 ? 3 : 4;
        } else if (productCount === 3) {
            return width < 576 ? productCountMobile :
                width < 750 ? 2 : 3;
        } else if (productCount === 2) {
            return width < 576 ? productCountMobile : 2;
        }
        return productCount;
    };

    const initPopularProducts = (section) => {
        const $section = $(section);

        if ($section.hasClass("slider_started")) {
            return;
        }

        $section.addClass("slider_started");

        let id = $section.attr("id");
        let slideEl = $section.find(".swiper-wrapper");
        let productCount = parseInt(slideEl.data("count"));
        let productCountMobile = parseInt(slideEl.data("count-mobile"));
        let slideCount = slideEl.find(".swiper-slide").length;

        const box = $section.find(".recently-viewed")[0];

        const autoplayEnabled = !!box && box.dataset.autoplay === "true";
        const pauseOnHover = !box || box.dataset.stopAutoplay !== "false";
        const speedSeconds = box && box.dataset.speed ? parseFloat(box.dataset.speed) : 0.6;
        const delaySeconds = box && box.dataset.delay ? parseFloat(box.dataset.delay) : 3;

        // Compute the *actual* slidesPerView for the current viewport up front,
        // instead of always starting from the desktop productCount.
        const initialSlidesPerView = getSlidesPerView(
            window.innerWidth,
            productCount,
            productCountMobile
        );

        // Only loop if there are enough slides to loop smoothly; otherwise
        // Swiper's loop mode can duplicate/skip slides awkwardly.
        const canLoop = slideCount > initialSlidesPerView * 2;

        let autoplayParams = {};
        if (autoplayEnabled) {
            autoplayParams = {
                autoplay: {
                    delay: delaySeconds * 1000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: pauseOnHover,
                },
            };
        }

        let prodSwiperParams = {
            loop: autoplayEnabled && canLoop,
            autoHeight: false,
            allowTouchMove: true,
            slidesPerView: initialSlidesPerView,
            lazy: true,
            preloadImages: false,
            spaceBetween: 16,
            breakpoints: {
                576: {
                    spaceBetween: 24,
                },
            },
            speed: speedSeconds * 1000,
            navigation: {
                nextEl: `#${id} .swiper-button-next`,
                prevEl: `#${id} .swiper-button-prev`,
            },
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            mousewheel: {
                forceToAxis: true,
            },
            ...autoplayParams,
        };

        let swiper = new Swiper(
            `#${id} .product-carousel-swiper`,
            prodSwiperParams
        );

        swiper.on("resize", function () {
            const w = window.innerWidth;
            this.params.slidesPerView = getSlidesPerView(w, productCount, productCountMobile);
        });
    };

    const initSection = async (section) => {
        if (!section || !section?.classList.contains("recently-viewed-section")) {
            return;
        }

        const box = section.querySelector(".recently-viewed");
        if (!box) return;

        const STORAGE_KEY = "__sf_theme_recently";
        const EXPIRATION_DAYS = box.dataset.expirationDays
            ? Number(box.dataset.expirationDays)
            : 30;
        const dateNow = Date.now();

        const baseUrl = box.dataset.baseUrl;
        const productsLimit = Number(box.dataset.productsLimit) || 6;
        const currentPageProductId = box.dataset.currentPageProductId;

        // get recent products from local storage
        let recentProducts = [];
        try {
            recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        } catch (e) {
            console.error(`Incorrect value in local storage for "${STORAGE_KEY}"`);
        }

        if (currentPageProductId) {
            recentProducts = recentProducts.filter(
                (item) => item.productId !== currentPageProductId
            );
        }

        if (recentProducts.length === 0) {
            box.classList.remove("recently-viewed--loading");
            box.classList.add("recently-viewed--empty");
            return;
        }

        // filter by expiration time
        const expirationTime = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
        const validProducts = recentProducts.filter(
            (item) => dateNow - item.timestamp < expirationTime
        );

        // limit by section setting
        const limitedProducts = validProducts.slice(0, productsLimit);

        // get url with query
        const query = limitedProducts
            .filter((item) => item.productId)
            .map((item) => `id:${item.productId}`)
            .join("%20OR%20");
        const url = `${baseUrl}&q=${query}`;

        try {
            const response = await fetch(url);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const sourceBox = doc?.querySelector(".recently-viewed");
            if (!sourceBox?.classList.contains("recently-viewed--search-perfomed")) {
                box.classList.add("recently-viewed--empty");
                return;
            }
            box.innerHTML = sourceBox.innerHTML;

            initPopularProducts(section);
            try {
                colorSwatches();
            } catch (err) {

            }
        } catch (error) {
            console.error("Failed to fetch recently viewed products:", error);
            box.classList.add("recently-viewed--empty");
        } finally {
            box.classList.remove("recently-viewed--loading");
        }
    };

    initSection(document.currentScript.parentElement);

    document.addEventListener("shopify:section:load", function (event) {
        initSection(event.target);
    });
})();